/**
 * Shared question image display – same logic as teacher View Question dialog.
 * Use this for test-taking, review, and view-question so image rendering is identical.
 */
import React from 'react';
import { Box } from '@mui/material';
import { resolveImageDisplayUrl } from '../../config/Config';

/**
 * Resolve display URL for question/sub-question image (prefer proxy URL).
 * Same as ViewQuestionDialog.getQuestionImageDisplayUrl.
 */
export function getQuestionImageDisplayUrl(q) {
  const url = q?.image_proxy_url || q?.image_url || '';
  return resolveImageDisplayUrl(url);
}

/**
 * Renders question image when present. Same img and styling as ViewQuestionDialog.
 * @param {Object} question - Object with image_proxy_url and/or image_url
 * @param {string} [alt='question']
 * @param {boolean} [compact] - If true, use smaller size (e.g. for review table)
 */
export function QuestionImage({ question, alt = 'question', compact = false }) {
  if (!question || (!question.image_proxy_url && !question.image_url)) return null;
  const style = compact
    ? { maxWidth: 120, maxHeight: 120, objectFit: 'contain', borderRadius: 8, border: '1px solid #e0e0e0' }
    : {
        maxWidth: '100%',
        maxHeight: 200,
        objectFit: 'contain',
        borderRadius: 8,
        border: '1px solid #e0e0e0',
      };
  return (
    <Box sx={{ mt: 1, mb: 1 }}>
      <img
        src={getQuestionImageDisplayUrl(question)}
        alt={alt}
        style={style}
      />
    </Box>
  );
}
